import React from "react";
import { Link } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

/**
 * Kullanım Şartları — Colossae Personel uygulamasının çalışanlar tarafından
 * kullanılmasına ilişkin genel hüküm ve koşullar. Kullanıcının açık istek
 * ve rızasıyla kullandığı, dışarıdan müdahale kabul etmediği ve
 * özgür iradesiyle her işlemi yaptığı yönündeki temel taahhütleri içerir.
 */
export default function TermsOfUse() {
  return (
    <div className="min-h-screen bg-background">
      <div className="max-w-3xl mx-auto p-6 space-y-6" data-testid="terms-page">
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-muted-foreground">Colossae Personel</div>
          <h1 className="font-display text-3xl font-bold mt-1">Kullanım Şartları</h1>
          <p className="text-sm text-muted-foreground mt-1">Son güncelleme: {new Date().toLocaleDateString("tr-TR", { year: "numeric", month: "long", day: "numeric" })}</p>
        </div>

        <Card><CardContent className="p-6 space-y-4 text-sm leading-relaxed">
          <section>
            <h2 className="font-display font-bold text-lg mb-1">1. Kabul ve Yürürlük</h2>
            <p>
              İşbu Kullanım Şartları, <b>Colossae Hotel</b> tarafından işletilen "Colossae Personel" uygulamasının
              ("Uygulama") tüm kullanıcıları (personel, müdür, İK sorumlusu, muhasebe müdürü, genel müdür ve admin)
              için geçerlidir. Uygulamaya kayıt olan veya kullanmaya başlayan her kullanıcı bu şartları okumuş ve
              kabul etmiş sayılır.
            </p>
          </section>

          <section>
            <h2 className="font-display font-bold text-lg mb-1">2. Kullanıcının Beyan ve Taahhütleri</h2>
            <p>Uygulamayı kullanan her kullanıcı aşağıdaki hususları kabul ve taahhüt eder:</p>
            <ul className="list-disc pl-5 mt-1 space-y-1">
              <li>
                Uygulamayı ve içerisindeki tüm işlemleri (izin talebi, imza atma, bordro onayı, mesajlaşma vb.)
                <b> kendi özgür istek ve rızasıyla</b>, hiçbir baskı, tehdit, cebir, yıldırma veya yönlendirme
                altında kalmadan gerçekleştirmektedir.
              </li>
              <li>
                Hesabına ait şifre, tanımlı cihaz ve imza bilgilerinin gizli tutulmasından bizzat sorumludur.
                Şifresini üçüncü kişilerle paylaşmaz.
              </li>
              <li>
                Yüklediği her belgenin (izin raporu, evrak, imza vb.) gerçek olduğunu; sahte, tahrif edilmiş veya
                başkasına ait bir belgeyi <b>bilerek yüklemeyeceğini</b> beyan eder.
              </li>
              <li>
                Uygulamaya yaptığı her giriş, verdiği her onay ve attığı her imzanın hukuki geçerliliği olan iradesi
                olduğunu; itiraz halinde denetim izleri (audit log) ile ispatlanabileceğini kabul eder.
              </li>
              <li>
                Bilgilerinde bir değişiklik olduğunda (adres, telefon, IBAN vb.) gecikmeksizin sistem üzerinden veya
                İK Sorumlusu vasıtasıyla güncellemekle yükümlüdür.
              </li>
            </ul>
          </section>

          <section>
            <h2 className="font-display font-bold text-lg mb-1">3. Uygulamanın Bağımsızlığı ve Bütünlüğü</h2>
            <p>
              Colossae Personel uygulamasına <b>Şirket ve yetkilendirilmiş personel dışında hiçbir üçüncü taraftan
              (harici sistem, danışman, tedarikçi veya kişi) müdahale edilemez</b>. Kısaca: <b>programa dışarıdan müdahale edilemez</b>.
              Uygulama içerisindeki yetkilendirme yapısı yalnızca Admin tarafından oluşturulur ve yönetilir. Bu bütünlüğün korunması
              için:
            </p>
            <ul className="list-disc pl-5 mt-1 space-y-1">
              <li>Tüm veriler Şirket'in kontrolü altındaki depolama alanlarında tutulur.</li>
              <li>Sisteme yalnızca kayıtlı kullanıcılar; yalnızca kendi rollerinin izin verdiği eylemleri gerçekleştirebilir.</li>
              <li>Kritik veri değişiklikleri (maaş, izin onayı, şifre) çift onay ve/veya imza gerektirir.</li>
              <li>Kaynak koda erişim yalnızca yetkilendirilmiş IT ekibine aittir.</li>
              <li>Şirket, verilerin bütünlüğüne yönelik her türlü yetkisiz erişim girişimini derhal soruşturur.</li>
            </ul>
          </section>

          <section>
            <h2 className="font-display font-bold text-lg mb-1">4. Yasak Kullanım</h2>
            <p>Aşağıdaki eylemler kesinlikle yasaktır:</p>
            <ul className="list-disc pl-5 mt-1 space-y-0.5">
              <li>Başka bir kullanıcının hesabına izinsiz giriş yapma denemesi</li>
              <li>Sahte belge, sahte imza veya sahte kimlik bilgisi yükleme</li>
              <li>Uygulamanın işleyişini bozmaya yönelik teknik saldırılar (DoS, tersine mühendislik vb.)</li>
              <li>Yönetici veya İK Sorumlusu adına sahte mesaj/duyuru gönderme</li>
              <li>Uygulamadaki verileri yetkisiz olarak dışarı aktarma, ekran görüntüsü ile paylaşma</li>
              <li>Diğer personelin özel bilgilerini (maaş, kimlik, IBAN, imza) yetki dışı kullanma</li>
            </ul>
            <p className="mt-2">
              Yukarıdaki maddelere aykırı davranışlar iş sözleşmesinin haklı nedenle feshine, tazminat talebine ve
              suç unsuru içeriyorsa Cumhuriyet Savcılığı'na suç duyurusuna yol açabilir.
            </p>
          </section>

          <section>
            <h2 className="font-display font-bold text-lg mb-1">5. Hesap Onay Süreci ve Yeniden Başvuru</h2>
            <p>
              Her yeni personel/müdür kayıtı Admin onayına tabidir. Kaydı reddedilen kullanıcılar aynı bilgilerle
              yeniden kayıt olabilir; bu durumda başvuru tekrar bekleme sırasına alınır. İki başvurunun aynı bilgileri
              içermesi yeni bir onay hakkını doğurur ancak Şirket'in kabul zorunluluğu bulunmaz.
            </p>
          </section>

          <section>
            <h2 className="font-display font-bold text-lg mb-1">6. Fikri Mülkiyet</h2>
            <p>
              Uygulamanın kaynak kodu, tasarım öğeleri, marka ve logolar Şirket'e aittir. Hiçbir kullanıcı Uygulama'nın
              bileşenlerini kopyalayamaz, tekrar dağıtamaz veya benzer bir sistem geliştirmek için tersine mühendislik yapamaz.
            </p>
          </section>

          <section>
            <h2 className="font-display font-bold text-lg mb-1">7. Uygulamanın Sunumu ve Kesintiler</h2>
            <p>
              Şirket, Uygulama'yı "olduğu gibi" sunar ve 7/24 kesintisiz çalışacağını taahhüt etmez. Bakım pencereleri
              önceden duyurulur. Uygulamada oluşabilecek geçici erişim aksaklıklarından dolayı Şirket'in kusuru yoksa
              sorumluluk kabul edilmez.
            </p>
          </section>

          <section>
            <h2 className="font-display font-bold text-lg mb-1">8. Uygulanacak Hukuk</h2>
            <p>
              İşbu şartlar Türk Hukuku'na tabidir. Uyuşmazlıklarda İstanbul (Merkez) Mahkemeleri ve İcra Daireleri
              yetkilidir.
            </p>
          </section>

          <div className="pt-4 border-t border-border text-center">
            <Button asChild variant="outline"><Link to="/login">Girişe Dön</Link></Button>
          </div>
        </CardContent></Card>
      </div>
    </div>
  );
}
